var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8538 5.85376C13.6138 5.85376 15.8538 8.09376 15.8538 10.8538C15.8538 13.6138 13.6138 15.8538 10.8538 15.8538C8.09376 15.8538 5.85376 13.6138 5.85376 10.8538C5.85376 8.09376 8.09376 5.85376 10.8538 5.85376ZM10.8538 3.85376C6.98376 3.85376 3.85376 6.98376 3.85376 10.8538C3.85376 14.7238 6.98376 17.8538 10.8538 17.8538C14.7238 17.8538 17.8538 14.7238 17.8538 10.8538C17.8538 6.98376 14.7238 3.85376 10.8538 3.85376Z",
    fill: "#262D30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4437 19.8538L14.1537 15.5638L15.5637 14.1538L19.8537 18.4438C20.2437 18.8338 20.2437 19.4638 19.8537 19.8538C19.4637 20.2438 18.8337 20.2438 18.4437 19.8538Z",
    fill: "#262D30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8b681768d77c8889374e22aad6cd06fe.svg";
export { ForwardRef as ReactComponent };